export default "__VITE_ASSET__91589c62__"